import styled from "styled-components";
import Select from "../../Select/Select";
export const PhoneNumberSelect = styled(Select.View) `
  // The select view will _grow larger, if the user has not selected an option
  // yet and has clicked the select to search something.
  &:not(.active) {
    width: 72px;
  }

  // Make the flag emoji smaller
  input::placeholder {
    font-size: 13px;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvbmVOdW1iZXJTZWxlY3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9QaG9uZU51bWJlci9zdHlsZWQvUGhvbmVOdW1iZXJTZWxlY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxNQUFNLE1BQU0scUJBQXFCLENBQUM7QUFFekMsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTs7Ozs7Ozs7Ozs7Q0FXbkQsQ0FBQyJ9